/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Shipping_N_Delivery__Question_1Inputs */

const en_help_center__shipping_n_delivery__question_1 = /** @type {(inputs: Help_Center__Shipping_N_Delivery__Question_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much does shipping cost?`)
};

/**
* | output |
* | --- |
* | "How much does shipping cost?" |
*
* @param {Help_Center__Shipping_N_Delivery__Question_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__shipping_n_delivery__question_1 = /** @type {((inputs?: Help_Center__Shipping_N_Delivery__Question_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Shipping_N_Delivery__Question_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__shipping_n_delivery__question_1(inputs)
});